// src/util/api.ts
import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const api = axios.create({
    baseURL: API_BASE,
    params: {
        format: 'json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('my-app-auth');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
